import React,{useEffect,useState} from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { GoogleLogin } from 'react-google-login';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as Actions from '../actions/Actions.js';
/** @jsx jsx */
import {jsx} from '@emotion/core'
import Form from "react-bootstrap/Form"
import PromiseButton from '../components/PromiseButton';
import debounce from "lodash/debounce";
import Spinner from "react-bootstrap/Spinner";
import AppleLogin from 'react-apple-login'
import Helper from '../functions/Helper.js';



const check_validity=(x,setUserNameValid)=>{
  if(x.length<3 || x.length >20){
    setUserNameValid("INVALID")
  }
  else{
    fetch(__server__ + '/API/pub/username_valid/'+x, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) =>response.json())
    .then((data)=>{
      if(data.result==="valid"){
        setUserNameValid("VALID")
      }
      else{
        setUserNameValid("INVALID")
      }
    })
  }
}

const debounce_check_validity=debounce(check_validity,500);


function Login(props){
  const [newUser,setNewUser]=useState(false);
  const [userName,setUserName]=useState("");
  const [userNameValid,setUserNameValid]=useState("UNCHECKED");
  const [socialData,setSocialData]=useState(null);
  const [showSpinner,setShowSpinner]=useState(false);

  const navigateNextScreen=()=>{
    if(props.history.location.state?.nextPath){
      props.history.push(props.history.location.state.nextPath);
    }
    else{
      props.history.push("/shoe-reviews");
    }
  }

  const createNewAccount=(userName,socialData)=>{
    setShowSpinner(true);
    fetch(__server__ + '/API/pub/user', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body:JSON.stringify({name:userName,...socialData})
    })
    .then((response) =>response.json())
    .then((data)=>{
      props.actions.login(data);
      navigateNextScreen()
    })
  }


  const facebook_login=(data)=>{
    setShowSpinner(true);
    fetch(__server__ + '/API/pub/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body:JSON.stringify({type:"facebook",token:data.accessToken})

    })
    .then((response) =>response.json())
    .then((apiData)=>{
      if(apiData.result==="loggedin"){
        props.actions.login(apiData);
        navigateNextScreen();
      }
      else if(apiData.result==="new_user"){
        setNewUser(true);
        setShowSpinner(false);
        setSocialData({type:"facebook",id:data.userID,email:data.email});
      }
    })
  }

  const google_login=(data)=>{
    setShowSpinner(true);
    fetch(__server__ + '/API/pub/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body:JSON.stringify({type:"google",token:data.tokenId})

    })
    .then((response) =>response.json())
    .then((apiData)=>{
      if(apiData.result==="loggedin"){
        props.actions.login(apiData);
        navigateNextScreen();
      }
      else if(apiData.result==="new_user"){
        setNewUser(true);
        setShowSpinner(false);
        setSocialData({type:"google",id:data.profileObj.googleId,email:data.profileObj.email});
      }
    })
  }

  const apple_login=(data)=>{
    setShowSpinner(true);
    fetch(__server__ + '/API/pub/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body:JSON.stringify({type:"apple_web",token:data.authorization.id_token})

    })
    .then((response) =>response.json())
    .then((apiData)=>{
      if(apiData.result==="loggedin"){
        props.actions.login(apiData);
        navigateNextScreen();
      }
      else if(apiData.result==="new_user"){
        let {email,sub} = Helper.parseJwt(data.authorization.id_token);
        setNewUser(true);
        setShowSpinner(false);
        setSocialData({type:"apple",id:sub,email:email});
      }
    })
  }

  return (
    <div style={{minHeight:"100vh"}}>
      <div css={{
          "@media (min-width:576px)":{
            padding:"40px 30px",
            width:400,
            border:"1px solid #ccc",
            margin:"100px auto 500px auto",
            backgroundColor:"#fdfdfd",
          },
          marginTop:"20vh",
          textAlign:"center",
        }}>
        {!newUser &&
          <>
            <div style={{fontSize:16,textAlign:"center",marginBottom:30,}}>Login to thehoopsgeek.com</div>
            <FacebookLogin
            redirectURI="https://www.thehoopsgeek.com/shoe-reviews/"
            isMobile={false}
            disableMobileRedirect={true}
            appId="403253844510758"
            fields="name,email,picture"
            render={renderProps => (
              <button onClick={renderProps.onClick} style={{width:250,fontSize:16,padding:"10px 20px",border:0,backgroundColor:"#4267B2",color:"#fff",fontWeight:600}}>
                <i style={{marginRight:10}} className="fab fa-facebook-f"/> Login with Facebook
              </button>
            )}
            callback={(x)=>facebook_login(x)}
            />
            <div style={{marginTop:10}}>
              <GoogleLogin
              redirectURI="https://www.thehoopsgeek.com/login/"
              uxMode={"popup"}
              render={renderProps => (
                <button onClick={renderProps.onClick} style={{width:250,fontSize:16,padding:"10px 20px",border:0,backgroundColor:"#4285f4",color:"#fff",fontWeight:600}}>
                  <i style={{marginRight:10}} className="fab fa-google"/>Login with Google
                </button>
              )}
              clientId="521451542472-8qli2d7dvjqrkp5vjfig204eut558aou.apps.googleusercontent.com"
              onSuccess={(x)=>{console.log("success",x);google_login(x)}}
              onFailure={(x)=>{console.log("error",x);}}
              cookiePolicy={'single_host_origin'}
            />
          </div>

          {/*}<div onClick={()=>{
            props.actions.login({token:"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2NDAzNDExODYsImV4cCI6MjY0MjkzMzE4NiwiZW5kdXNlcl9pZCI6IjIyIiwidHlwZSI6ImZhY2Vib29rIn0.80pCZiqFNDDC6MSrAWNKUl5PUc4vFNjU7IMGDc7PsEc"});
            }}>
            Fake Login
          </div> */}
          {
          <div style={{marginTop:10}}>
            <AppleLogin
              usePopup={true}
              redirectURI={"https://www.thehoopsgeek.com"}
              callback={(x)=>apple_login(x)}
              clientId="com.thehoopsgeek"
              render={renderProps => (
                <button onClick={renderProps.onClick} style={{width:250,fontSize:16,padding:"10px 20px",border:0,backgroundColor:"#424242",color:"#fff",fontWeight:600}}>
                  <i style={{marginRight:10}} className="fab fa-apple"/>Login with Apple
                </button>
              )}
            />
          </div>}
        </>
      }
      {newUser &&
        <div style={{textAlign:"left",marginTop:30,fontSize:16,}}>
          <div>We couldn't find an existing account with these login details.</div>
          <div style={{fontWeight:600,marginBottom:10,marginTop:20,}}>Pick a username to create a new account:</div>
          <Form style={{marginBottom:20}}>
            <Form.Control
              type="text"
              onChange={(x)=>{
                setUserName(x.target.value);
                debounce_check_validity(x.target.value,setUserNameValid);
              }}
              isInvalid={userNameValid==="INVALID"}
              isValid={userNameValid==="VALID"}
              style={{}}
              as="input"
              value={userName}
              placeholder="" />
            <Form.Control.Feedback type="invalid">
              Username already taken or invalid (must be between 3 and 20 characters)
            </Form.Control.Feedback>
          </Form>
          <PromiseButton disabled={userNameValid!=="VALID"} onClick={()=>{createNewAccount(userName,socialData)}}>
            Create Account
          </PromiseButton>
        </div>
      }

      {!newUser &&
        <div style={{fontSize:12,marginTop:20}}>Not a member yet? Pick a login option to create an account.</div>
      }
      {showSpinner &&
        <div style={{alignItems:"center", justifyContent:"center",display:"flex",paddingTop:25}}>
          <Spinner size="sm" animation="border" variant="primary"/>
          <div style={{marginLeft:10,fontSize:16}}>Logging in ...</div>
        </div>
      }

    </div>
  </div>
  );
}

export default connect(state => ({...state.persistData}), (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch)
}))(Login);
